import React, { useEffect } from 'react';
import AttendanceDetailReportDataTable from './AttendanceDetailReportDataTable';

const AttendanceDetailReportIndex = ({ rrhh, verticalTotals }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <AttendanceDetailReportDataTable rrhh={rrhh} verticalTotals={verticalTotals} />;
};

export default AttendanceDetailReportIndex;
